/**
 * ContractEstimateSlice State Definition
 * 
 * Defines the state interface and initial state for the contract estimate slice.
 */

import { ContractEstimate, CenterOption, PayerOption } from '../types/contractEstimateTypes';

/**
 * State interface for the contract estimate slice.
 */
export interface ContractEstimateSliceState {
  /** The current estimate being worked on, or null if none */
  currentEstimate: ContractEstimate | null;
  /** List of saved estimates */
  savedEstimates: ContractEstimate[];
  /** Available centers for selection */
  availableCenters: CenterOption[];
  /** Available payers for selection */
  availablePayers: PayerOption[];
  /** Whether data is currently loading */
  isLoading: boolean;
  /** Whether calculation is in progress */
  isCalculating: boolean;
  /** Whether any edits have been made since loading/saving */
  isDirty: boolean;
  /** Validation errors keyed by field name */
  validationErrors: Record<string, string>;
}

/**
 * Initial state for the contract estimate slice.
 */
export const initialState: ContractEstimateSliceState = {
  currentEstimate: null,
  savedEstimates: [],
  availableCenters: [],
  availablePayers: [],
  isLoading: false,
  isCalculating: false,
  isDirty: false,
  validationErrors: {},
};
